import React, {useState,  useEffect } from 'react';
import DeckGL, { MapView } from 'deck.gl';

import { load } from "@loaders.gl/core";
import { ZipLoader } from "@loaders.gl/zip";

import { fromArrayBuffer } from 'geotiff';

import * as turf  from "@turf/turf"

import { renderLayers } from "./RenderLayers";


const mainView = new MapView({ 
    id: 'main', 
    controller: true,
 });
const minimapView = new MapView({
    id: 'minimap',
    x: 0,
    y: 0,
    repeat:true,
    width:"100%",
    height: '300px',
});


const layerFilter = ({ layer, viewport }) => {


    if (viewport.id === 'minimap'){
        if (layer.id.startsWith("tile-layer")) {
            return true;
        }
        else if (layer.id.startsWith("scatterplot-layer")){
            return true
        }
        else{
            return false;
        }
    }

    if (viewport.id === 'main') {
        if (layer.id.startsWith("tile-layer")) {
            return false;
        } else {
            return true;
        }
    }

}


// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    main:{
        latitude: 35.6454067085032,
        longitude: 138.33657520639863,
        pitch: 60,
        zoom: 9.2
    },
    minimap:{
        latitude: 35.8454067085032,
        longitude: 130.4,
        zoom: 0.5
    }
};

const minimapBackgroundStyle = {
    position: 'absolute',
    zIndex: -1,
    width: '100%',
    height: '100%',
    background: '#fefeff',
    boxShadow: '0 0 8px 2px rgba(0,0,0,0.15)'
};

const textureConfig = {
    "Everest_dem": "./data/Everest_img.png",
    "Fuji_dem": "./data/Fuji_img.png",
    "Kangchenjunga_dem": "./data/Kangchenjunga_img.png",
    "Kinabalu_dem": "./data/Kinabalu_img.png",
    "Semeru_dem": "./data/Semeru_img.png",
    "K2_dem": "./data/K2_img.png",
}


function Map() {
    const [tiffData, setTiffData] = useState(null);
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE);
    const [selectPoint, setSelectPoint] = useState(null);


    //GeoJSONデータの読み込み
    useEffect(()=>{

    
        const loadTiff = async (url)=>{
            const zip = await load(url, ZipLoader);
            const key = Object.keys(zip);
            const tiff = await fromArrayBuffer(zip[key[0]]);
            const name = key[0].split(".")[0]

            const image = await tiff.getImage(0);
            const bbox = image.getBoundingBox();
            const { width, height } = await image.readRasters(); //get raster info
            const data = await image.readRasters();
            const res = {
                name:name,
                data: data,
                bbox: bbox,
                width: width,
                height: height,
            }

            return res;

        }


        const loadDemDataset = async() => {
            
            const everest = await loadTiff("./data/Everest_dem.zip");
            everest.texture = textureConfig[everest.name];

            const k2 = await loadTiff("./data/K2_dem.zip");
            k2.texture = textureConfig[k2.name];

            const kangchenjunga = await loadTiff("./data/Kangchenjunga_dem.zip")
            kangchenjunga.texture = textureConfig[kangchenjunga.name];


            const semeru = await loadTiff("./data/Semeru_dem.zip"); //スメル山
            semeru.texture = textureConfig[semeru.name];


            const kinabalu = await loadTiff("./data/Kinabalu_dem.zip");
            kinabalu.texture = textureConfig[kinabalu.name];


            const fuji =  await loadTiff("./data/Fuji_dem.zip");
            fuji.texture = textureConfig[fuji.name];


            setTiffData({ everest, k2, kangchenjunga, semeru, kinabalu ,fuji });
            
        }

        loadDemDataset()

    },[])

    const handlehover = (e)=>{
        if(!e.layer){
            setSelectPoint(null)
            return null
        };
        const latlng = e.layer.latlng
        setSelectPoint(latlng)
    }


    return (
        <div>
            <canvas id="canvas"></canvas>
            <DeckGL
                id={"deck"}
                //style={{display:"none"}}
                //effects={effects}
                //
                views={[mainView, minimapView]}
                initialViewState={viwState}
                controller={{ inertia: true, dragRotate:false}}
                layers={renderLayers({ tiffData, selectPoint })}
                layerFilter={layerFilter}
                onHover={handlehover}
                //onViewStateChange={v=>console.log(v.viewState)}
            >
                <MapView id="main">
                </MapView>                
                <MapView id="minimap">
                    <div style={minimapBackgroundStyle} />
                </MapView>                
            </DeckGL>
            <div id="fieldset">
                <legend>Asian Mountains</legend>
            </div>

        </div>
    );
}

export default Map;